export default __webpack_public_path__ + "static/media/message-pop-alert.e2e956ce.mp3";